if (!customElements.get('header-product-menu')) {
  customElements.define('header-product-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const links = this.querySelectorAll('[data-product-panel]');
      const panels = this.querySelectorAll('[data-product-content]');
      const activate = (link) => {
        // Do not hide a product link that still holds keyboard focus.
        if (Array.from(panels).some((panel) => panel.contains(document.activeElement))) return;
        links.forEach((item) => item.classList.toggle('is-active', item === link));
        panels.forEach((panel) => { panel.hidden = panel.id !== link.dataset.productPanel; });
      };
      links.forEach((link) => {
        link.addEventListener('mouseenter', () => activate(link));
        link.addEventListener('focus', () => activate(link));
      });
    }
  });
}
